import React, { useState, useEffect, useRef } from 'react';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import SuperAdminSidebar from './Sidebar/SuperAdminSidebar';
import InactiveCompanyRestriction from '../InactiveCompanyRestriction';
import styles from './Layout.module.scss';
import { useNavigate, useLocation } from 'react-router-dom';

const Layout: React.FC<{ children: React.ReactNode; role?: string; permissions?: any }> = ({ 
  children, 
  role,
  permissions = {}
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const idleTimeout = useRef<NodeJS.Timeout | null>(null);

  // useEffect(() => {
  //   const IDLE_TIME = 5 * 60 * 1000; // 5 minutes in milliseconds

  //   const resetTimer = () => {
  //     if (idleTimeout.current) clearTimeout(idleTimeout.current);
  //     idleTimeout.current = setTimeout(() => {
  //       if (location.pathname !== '/dashboard') {
  //         navigate('/dashboard');
  //       }
  //     }, IDLE_TIME);
  //   };

  //   const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
  //   events.forEach(event => window.addEventListener(event, resetTimer));
  //   resetTimer();

  //   return () => {
  //     if (idleTimeout.current) clearTimeout(idleTimeout.current);
  //     events.forEach(event => window.removeEventListener(event, resetTimer));
  //   };
  // }, [navigate, location.pathname]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Use SuperAdminSidebar for super admin users
  const SidebarComponent = role === 'super_admin' ? SuperAdminSidebar : Sidebar;

  return (
    <InactiveCompanyRestriction>
      <div className={styles.layout}>
        <Header onMenuToggle={toggleSidebar} />
        <div className={styles.body}>
          {/* Mobile sidebar overlay */}
          <div 
            className={`${styles.sidebarOverlay} ${sidebarOpen ? styles.active : ''}`}
            onClick={closeSidebar}
          />
          
          {/* Sidebar container */}
          <div className={`${styles.sidebarContainer} ${sidebarOpen ? styles.active : ''}`}>
            <SidebarComponent 
              role={role} 
              permissions={permissions} 
              onClose={closeSidebar}
              isMobile={sidebarOpen}
            />
          </div>
          
          <main className={styles.main}>
            {children}
          </main>
        </div>
      </div>
    </InactiveCompanyRestriction>
  );
};

export default Layout; 
